const initialState = {
  defaultTariff: {
    tariffId: null,
    baseTariffId: null,
    name: null,
    basicFee: null,
    connectionFee: null
  },
  selectedTariff: null,
  selectedAboOption: null,
  defaultTariffLoadingStatus: '',
  backendErrorCode: null,
  volumes: [],
  selectedVolume: '',
  starterKit: [],
  selectedStarterKit: [],
  kwkId: '162'
}

const CheckoutTariffModule = {
  namespaced: true,
  state: initialState,
  getters: {
    defaultTariff: state => {
      return state.defaultTariff
    },
    minTariffBasicFee: state => {
      return state.minTariffBasicFee
    },
    selectedTariff: state => {
      return state.selectedTariff
    },
    finalTariffId: state => {
      return state.selectedTariff ? state.selectedTariff.tariffId : state.defaultTariff.tariffId
    },
    defaultTariffLoadingStatus: state => {
      return state.defaultTariffLoadingStatus
    },
    volumeByTariffId: state => tariffId => {
      if (state.volumes && state.volumes[tariffId]) {
        state.volumes[tariffId].forEach(v => {
          if (v.formattedUnit === 'GB') {
            if (state.selectedAboOption?.volumes[0]?.formattedUnit === 'GB') {
              state.selectedVolume = v.amount + state.selectedAboOption.volumes[0].amount + ' ' + v.formattedUnit
            } else {
              state.selectedVolume = v.amount + ' ' + v.formattedUnit
            }
          }
        })
      }
    },
    isSelectedAboOption: state => {
      return state.selectedAboOption !== null
    },
    seletedVolume: state => {
      return state.selectedVolume
    },
    selectedAboOption: state => {
      return state.selectedAboOption
    },
    selectedAboOptionId: state => {
      return state.selectedAboOption?.tariffoptionId || null
    },
    starterKitByTariffId: state => tariffId => {
      if (state.starterKit && state.starterKit[tariffId]) {
        state.selectedStarterKit = state.starterKit[tariffId][0]
      }
    },
    selectedStarterKit: state => {
      return state.selectedStarterKit
    },
    findTarifOption: state => optionIds => {
      if (state.defaultTariff?.tariffOptions?.bookablePresalesTariffOptions) {
        return state.defaultTariff.tariffOptions.bookablePresalesTariffOptions.filter((el) => {
          return optionIds.includes(el.tariffoptionId)
        })
      } else {
        return []
      }
    },
    checkKwk: state => bookedTariffId => {
      if (bookedTariffId === undefined) { return undefined }
      return bookedTariffId === state.kwkId
    }
  },
  actions: {
    async loadDefaultTariff ({ commit, state, rootGetters }) {
      // initialize
      commit('clearMessages', {}, { root: true })

      // check for prefetched data
      if (typeof window.$gqlpre.defaultTariffNoMnp !== 'undefined' && typeof window.$gqlpre.bookablePresalesTariffs !== 'undefined') {
        let defaultTariff = window.$gqlpre.defaultTariffNoMnp
        if (state.selectedTariff && state.selectedTariff.tariffId === '162') {
          defaultTariff = state.selectedTariff
        }
        commit('SET_DEFAULT_TARIFF', defaultTariff)
        commit('SET_LOADING_STATUS', 'LOADED')
        commit('SET_BACKEND_ERROR_CODE', null)
        commit('SET_SELECTED_TARIFF', defaultTariff)
        // get min tariff and volumes
        let minTariffBasicFee = 99999
        const volumes = {}
        const starterKit = {}
        window.$gqlpre.bookablePresalesTariffs.forEach(v => {
          if (v.basicFee < minTariffBasicFee) {
            minTariffBasicFee = v.basicFee
          }
          volumes[v.tariffId] = v.volumes
          starterKit[v.tariffId] = v.starterKit
        })
        volumes['162'] = volumes['155']
        starterKit['162'] = starterKit['155']
        commit('SET_MIN_TARIFF_BASIC_FEE', minTariffBasicFee)
        commit('SET_TARIFF_VOLUMES', volumes)
        commit('SET_TARIFF_STARTERKIT', starterKit)
      } else {
        commit('SET_LOADING_STATUS', 'ERROR')
      }
    },
    setSelectedTariff ({ state, commit }, tariff) {
      commit('SET_SELECTED_TARIFF', tariff)
    },
    setSelectedAboOption ({ state, commit }, tariff) {
      commit('SET_SELECTED_ABO_OPTION', tariff)
    },
    setSelectedTariffToDefault ({ state, commit }) {
      commit('SET_SELECTED_TARIFF', state.defaultTariff)
    },
    resetTariffDefaultState ({ commit, state }) {
      // initialize
      commit('clearMessages', {}, { root: true })
      commit('resetState', state)
    }
  },
  mutations: {
    SET_DEFAULT_TARIFF (state, tariff) {
      state.defaultTariff = tariff
    },
    SET_MIN_TARIFF_BASIC_FEE (state, tariff) {
      state.minTariffBasicFee = tariff
    },
    SET_SELECTED_TARIFF (state, tariff) {
      state.selectedTariff = tariff
    },
    SET_SELECTED_ABO_OPTION (state, option) {
      state.selectedAboOption = option
    },
    SET_LOADING_STATUS (state, status) {
      state.defaultTariffLoadingStatus = status
    },
    SET_BACKEND_ERROR_CODE (state, errorcode) {
      state.backendErrorCode = errorcode
    },
    SET_TARIFF_VOLUMES (state, volumes) {
      state.volumes = volumes
    },
    SET_TARIFF_STARTERKIT (state, starterKit) {
      state.starterKit = starterKit
    },
    resetState (state) {
      Object.assign(state, initialState)
    }
  }
}

export default CheckoutTariffModule
